module.exports = __webpack_public_path__ + "img/stoneholder-1.da8e309.webp";